import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Product from "./steps/Product";
import Details from "./steps/Details";
import Design from "./steps/Design";
import Contact from "./steps/Contact";
import { useAddQuoteMutation } from "../organizations/api/quoteApi";
import useOrganizationId from "@/hooks/useOrganizationId";
import FormikStepper from "@/components/formik-stepper/FormikStepper";
import { Product as IProduct, ProductId, products } from "./constants";
import { NewQuote } from "@/types/quote";
import { Helmet } from "react-helmet-async";
import useOrganizations from "../organizations/useOrganizations";
import { Stack, useTheme } from "@mui/material";

const steps = [
  {
    title: "Producto",
    stepTitle: "¿Qué deseas imprimir?",
    component: Product,
    schema: Yup.object().shape({
      product: Yup.string().strict(true).required("Necesitas elegir un producto para poder continuar."),
      quantity: Yup.number()
        .strict(true)
        .required("Es necesario definir una cantidad en específica.")
        .test("product", "No puedes elegir una cantidad menor que la mínima", (quantity, context) => {
          // get product data using id
          const productId = context.parent.product as ProductId;
          const product = products[productId ?? ""] as unknown as IProduct;

          if (!product) return false;

          // get min value from product
          const minQuantity = product.minQuantity;

          // add validation
          if (quantity >= Number(minQuantity)) {
            return true;
          } else {
            return context.createError({
              message: () => `No puedes elegir una cantidad menor a ${minQuantity}`,
            });
          }
        }),
    }),
  },
  {
    title: "Detalles",
    stepTitle: "¿ Cómo lo deseas ?",
    component: Details,
    schema: Yup.object().shape({
      material: Yup.string().strict(true).required("Elegir un material es necesario."),
      finishing: Yup.string().strict(true).required("Elegir un acabado es necesario."),
      dimention: Yup.string().strict(true).required("Elegir una dimensión es necesario."),
      printing: Yup.string().strict(true).required("Elegir un tipo de impresión es necesario."),
    }),
  },
  {
    title: "Diseño",
    stepTitle: "Diseño",
    component: Design,
    schema: Yup.object().shape({
      design: Yup.string().strict(true).required("Debes seleccionar una opción de diseño."),
    }),
  },
  {
    title: "Contacto",
    stepTitle: "Contáctanos",
    component: Contact,
    schema: Yup.object().shape({
      contact: Yup.object().shape({
        name: Yup.string().strict(true).required("Necesitas llenar tu nombre"),
        phone: Yup.string().strict(true).required("Necesitas colocar un teléfono."),
        email: Yup.string(),
        message: Yup.string(),
      }),
    }),
  },
];

const Quote = () => {
  const navigate = useNavigate();
  const organizationId = useOrganizationId();
  const { currentOrganization } = useOrganizations();
  const [addQuote, addQuoteMutation] = useAddQuoteMutation();

  type FormValues = Omit<NewQuote, "createdAt">;

  const handleSubmit = async (values: FormValues) => {
    try {
      if (!organizationId) return;
      await addQuote({ organizationId, payload: values });
      navigate("/cotizacion/gracias");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Stack sx={{ backgroundColor: "#DDEAFD" }}>
      <Helmet>
        <title>Solicitud de cotización | {currentOrganization?.title ?? ""}</title>
      </Helmet>
      <FormikStepper headerTitle="Solicitud de cotización" steps={steps} onSubmit={handleSubmit} disabled={addQuoteMutation.isLoading} hideStepper />
    </Stack>
  );
};

export default Quote;
